<template>
  <vf-button
    v-if="available"
    :aria-label="$t.chatCta.chat"
    class="fixed right-5 flex center rounded-full <lg:bottom-25 lg:bottom-15 bg-brand-4"
    data-sierra-launcher
    style="width: 3.125rem; height: 3.125rem; z-index: 12"
    @click="handleClick"
  >
    <vf-icon class="c-white" name="chat-sierra" size="md" />
  </vf-button>
</template>

<script setup lang="ts">
const { $chat } = useNuxtApp()
const available = $chat.available

const handleClick = () => $chat.open()
</script>
